'use strict';

function getManageData(deps) {
	function hasUserInfoRoles(config) {
		return config && config.UserInfo && config.UserInfo.roles;
	}

	return {

		getAccountUrl: function() {
			return '/account/home';
		},

		getChannelUrl: function(config) {
			var _ = deps.underscore;
			if (!hasUserInfoRoles(config)) return '';

			var ROLES = config.UserInfo.roles;
			var isChannelAdmin = _.contains(ROLES, 'CHANNEL_ADMIN');
			var isChannelProductSupport = _.contains(ROLES, 'CHANNEL_PRODUCT_SUPPORT');
			var isChannelProductSupportOnly = !isChannelAdmin && isChannelProductSupport;
			var CHANNEL = config.CHANNEL_SETTINGS;
			var isBaas = CHANNEL.baas;
			var CHANNEL_PROGRESS_PAGES = 6; // keep in sync with monolith
			var isChannelGuideInProgress = CHANNEL.walkMeEnabled && CHANNEL.guideProgresses && CHANNEL.guideProgresses.CHANNEL < CHANNEL_PROGRESS_PAGES;
			var url = '/channel/marketplace';

			if (isChannelProductSupportOnly && !isBaas) {
				url = '/channel/products';
			} else if (isChannelAdmin && isChannelGuideInProgress) {
				url = '/channel/guide';
			}

			return url;
		},

		getCorporateUrl: function() {
			return '/corporate/home';
		},


		getInsightUrl: function(app) {
			return app ? app.launchUrl : '';
		},

		getDeveloperUrl: function() {
			return '/cms/home';
		},

		getResellerUrl: function() {
			return '/reseller';
		},

		getSuperUserUrl: function(config) {
			var _ = deps.underscore;
			if (!hasUserInfoRoles(config)) return '';

			return _.contains(config.UserInfo.roles, 'SUPERUSER') ? '/superuser/dashboard' : '/superuser/support';
		}
	};
}

module.exports = {
	getManageData: getManageData
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/models/manage-urls.js
// module id = 7
// module chunks = 0